var $ = jQuery.noConflict();

/* Script on ready
------------------------------------------------------------------------------*/
$( document ).ready( function() {
    // Currency select
    $('.multicurrency-selector__select').on('change', function() {
        this.form.submit();
    });
   
	//do jQuery stuff when DOM is ready

	/* Responsive Jquery Navigation */
	$( '.hamburger' ).click( function( event ) {
		$( '.mobilenav' ).toggleClass( 'is-open' );
	} );

	$( '.mobilenav .nav-backdrop' ).click( function() {
		$( '.mobilenav' ).removeClass( 'is-open' );
	} );

	var clickable = $( '.menu-state' ).attr( 'data-clickable' );
	$( '.mobilenav li:has(ul)' ).addClass( 'has-sub' );
	$( '.mobilenav .has-sub>a' ).after( '<em class="caret">' );
	if ( clickable == 'true' ) {
		$( '.mobilenav .has-sub>.caret' ).addClass( 'trigger-caret' );
	} else {
		$( '.mobilenav .has-sub>a' ).addClass( 'trigger-caret' ).attr( 'href','javascript:;' );
	}

	/* menu open and close on single click */
	$( '.mobilenav .has-sub>.trigger-caret' ).click( function() {
		var element = $( this ).parent( 'li' );
		if ( element.hasClass( 'is-open' ) ) {
			element.removeClass( 'is-open' );
			element.find( 'li' ).removeClass( 'is-open' );
			element.find( 'ul' ).slideUp( 200 );
		}
		else {
			element.addClass( 'is-open' );
			element.children( 'ul' ).slideDown( 200 ) ;
			element.siblings( 'li' ).children( 'ul' ).slideUp( 200 );
			element.siblings( 'li' ).removeClass( 'is-open' );
			element.siblings( 'li' ).find( 'li' ).removeClass( 'is-open' );
			element.siblings( 'li' ).find( 'ul' ).slideUp( 200 );
		}
	} );
// featured collection

$('.product-grid').each(function(){
  if(!$("body").hasClass("template-search")){
      var _this = $(this);
      _this.on('init', function(event, slick) {
          if (_this.find('.slick-slide').length <= 4) {
              _this.find('.slick-dots').show();
          }
      });
      _this.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              dots: true,
              arrows:false,
            }
          },
           {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              dots: true,
              arrows:false,
            }
           }
          ]
      });
  }
  
  
});

// related items
  $('.related-items-grid').slick({  
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    autoplaySpeed: 2000,
    arrows:true,
    draggable: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,              
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
});
	// our-fleet

	$('.product-img-wrapper').slick({
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		button: false,
		arrows: true,
		dots: false,
       responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
	  });
  // left-right-slider

  $('.left-right-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    
  });

  //slider-widget.liquid
   $('.home-slider-autoplay').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000
  });
  
  // collab slider
  $('.collab-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
     dots: true,
    arrows: false,
  });
  
  // koi slider
  $('.coverflow').flipster({
    style: 'carousel',
    spacing: -0.5,
    buttons: true,
    loop: true,
  });
  
  // Header discount section 
  


  // delivery accordian


  $('.question').click(function(e) {
      e.preventDefault();
      $(this).next().slideToggle(350).parent().siblings().find('.answer').slideUp(350);
      $(this).parent('.question-wrap').toggleClass('active').siblings().removeClass('active');
  });
  
  
} );

/* Script on load
------------------------------------------------------------------------------*/
$( window ).on( 'load',function() {
	// page is fully loaded, including all frames, objects and images

} );

/* Script on scroll
------------------------------------------------------------------------------*/
$( window ).on( 'scroll',function() {

    var timer;
    $(window).bind('scroll',function () {
        clearTimeout(timer);
        timer = setTimeout( refresh , 150 );
    });
    var refresh = function () { 
        var nearestElement = false;
        var elementFromtop = 0;
        $(".custompanel, .shopify-section").each(function(){

            if(!isOnScreen($(this))){
                return;
            }

            if(!isElementAboveHeight($(this))){
                return;
            }

            nearestElement = $(this);
        });

        if(nearestElement){
            var sectionId = nearestElement.attr("id");
            $(".scrollNav li a").removeClass("active");
            $("a[href='#"+sectionId+"']").addClass("active");
        }
        
    };
} );

function isElementAboveHeight(elem){

    var totalScroll = $(window).scrollTop();
    var elementOffset = elem.offset().top;
    var travelling = elementOffset - totalScroll;
    var halfWindowHeight = $(window).height() / 2;
    
    if(travelling < halfWindowHeight){
        return true;
    }
    return false;
}

function isOnScreen(elem) {
    // if the element doesn't exist, abort
    if( elem.length == 0 ) {
        return;
    }
    var $window = jQuery(window)
    var viewport_top = $window.scrollTop()
    var viewport_height = $window.height() - 105
    var viewport_bottom = viewport_top + viewport_height
    var $elem = jQuery(elem)
    var top = $elem.offset().top
    var height = $elem.height()
    var bottom = top + height

    return (top >= viewport_top && top < viewport_bottom) ||
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

/* Script on resize
------------------------------------------------------------------------------*/
$( window ).on( 'resize',function() {

} );

/* Script all functions
------------------------------------------------------------------------------*/

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    var flag = true;

    const sections = document.querySelectorAll("section .panel");

    const scrolling = {
        enabled: true,
        events: "scroll,wheel,touchmove,pointermove".split(","),
        prevent: e => e.preventDefault(),

        disable() {
            if (scrolling.enabled) {
                scrolling.enabled = false;
                window.addEventListener("scroll", gsap.ticker.tick, {passive: true});
                scrolling.events.forEach((e, i) => (i ? document : window).addEventListener(e, scrolling.prevent, {passive: false}));
            }
        },
        enable() {
            if (!scrolling.enabled) {
                scrolling.enabled = true;
                window.removeEventListener("scroll", gsap.ticker.tick);
                scrolling.events.forEach((e, i) => (i ? document : window).removeEventListener(e, scrolling.prevent));
            }
        }
    };
    
    let links = gsap.utils.toArray(".scrollNav a");
    gsap.utils.toArray(".scrollNav a").forEach(function(a, i) {
        a.addEventListener("click", function(e) {
            flag = false;
            e.preventDefault();

            var addtionalTop = 0;
            if($(window).width() > 990){
              addtionalTop = 50;
            }

            if($(a).hasClass("firstitem")){
              addtionalTop = addtionalTop + 50;
            }
            
            var height = $(e.target.getAttribute("href")).offset().top;
            var headerHeight = $("#shopify-section-header").height();
            var scrollHeight = parseInt(height) - parseInt(headerHeight) - addtionalTop;
            
            gsap.to(window, {duration: 1, scrollTo: scrollHeight});
            let links = gsap.utils.toArray(".scrollNav a");
                links.forEach(el => el.classList.remove("active"));
            a.classList.add("active");
            setTimeout(() => {
                flag = true;
            }, 1500);           
        });
    });
    
    function goToSection(section, i, anim) {
        if(flag) {
            if (scrolling.enabled) { // skip if a scroll tween is in progress
                scrolling.disable();
                gsap.to(window, {
                    scrollTo: {y: section, autoKill: false},
                    onComplete: scrolling.enable,
                    duration: 1
                });
                anim && anim.restart();
                let links = gsap.utils.toArray(".scrollNav a");
                links.forEach(el => el.classList.remove("active"));
                links[i].classList.add("active");
            }
        }
    }
    let scrollNav = gsap.timeline({
        scrollTrigger: {
            trigger: ".the-camera", // What element triggers the scroll
            scrub: 0.5, // Add a small delay of scrolling and animation. `true` is direct
            start: "top bottom-=1",
            end: "bottom center",
            pin: false, // Pin the element true or false
            markers: false,
            toggleClass: "active"
        }
    });

    sections.forEach((section, i) => {
        ScrollTrigger.create({
            trigger: section,
            start: "top bottom-=1",
            end: "bottom top+=1",
            onEnter: () => goToSection(section, i),
            onEnterBack: () => goToSection(section, i)
        });
    });
  
